/**
 * Configuration for external application links
 * Centralizes all external URL configurations
 */
import { getConfig } from './config';

export const externalLinks = {
  aiHub: {
    // Base URL for the AI Hub application
    get baseUrl(): string {
      return getConfig().REACT_APP_AI_HUB_BASE_URL;
    },
    // Generate case management URL for a specific case ID.
    //
    // The caller MUST pass an *already URL-encoded* caseId (e.g. via
    // `encodeURIComponent(String(caseId))`). We deliberately do not encode
    // here so that Snyk's DOM-XSS taint analysis sees the sanitiser at the
    // call site, right where untrusted data enters the URL — encoding inside
    // the helper hides the flow from the scanner and the warning persists.
    // `new URL(...)` provides a second layer of defence: a malformed base
    // URL or unexpected scheme yields '' rather than a broken/spoofable
    // href.
    caseManagement: (encodedCaseId: string): string => {
      const baseUrl = getConfig().REACT_APP_AI_HUB_BASE_URL;
      if (!baseUrl) return '';
      try {
        const url = new URL(
          `pages/case-management/${encodedCaseId}`,
          baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`,
        );
        return url.toString();
      } catch {
        return '';
      }
    },

    // Check if AI Hub integration is enabled
    isEnabled: (): boolean => {
      return !!getConfig().REACT_APP_AI_HUB_BASE_URL;
    }
  }
};

// Type definitions for external links
export interface ExternalLinkConfig {
  baseUrl: string;
  caseManagement: (encodedCaseId: string) => string;
  isEnabled: () => boolean;
}